export default __webpack_public_path__ + "static/media/mpsp.f419fbc0.svg";